import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState } from "@/store";

const RootRedirect: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useSelector(
    (state: RootState) => state.auth,
  );
  const navigate = useNavigate();

  useEffect(() => {
    // Don't redirect while loading
    if (isLoading) return;

    if (isAuthenticated && user) {
      // Redirect authenticated users to their dashboard
      const dashboardPath = getDashboardPath(user.role);
      navigate(dashboardPath, { replace: true });
    } else {
      // Redirect unauthenticated users to home page
      navigate("/home", { replace: true });
    }
  }, [isAuthenticated, user, isLoading, navigate]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
      </div>
    );
  }

  return null;
};

// Helper function to determine dashboard path based on user role
const getDashboardPath = (role: string): string => {
  switch (role) {
    case "admin":
    case "manager":
    case "staff":
      return "/admin/dashboard";
    case "CourierOwner":
    case "FleetOwner":
    case "RestaurantOwner":
      return "/maintenance";
    case "DeliveryDriver":
    case "driver": // Legacy support
    case "ScooterDriver":
    case "VehicleDriver":
      return "/driver/dashboard";
    default:
      return "/driver/dashboard";
  }
};

export default RootRedirect;
